export const teal = {
  500: 'hsla(174, 100%, 29%, 1)',
  300: 'hsla(174, 42%, 51%, 1)',
  200: 'hsla(174, 42%, 65%, 1)',
  100: 'hsla(175, 41%, 79%, 1)',
  50: 'hsla(177, 41%, 91%, 1)',
};

export type TealPalette = typeof teal;
